import React from "react";

/**
 * Converts inline <br/> strings in text into actual <br /> JSX elements.
 * Usage: renderWithBreaks("Hello<br/>World") → ["Hello", <br />, "World"]
 */
export const renderWithBreaks = (text: string): React.ReactNode => {
  const parts = text.split("<br/>");
  if (parts.length === 1) return text;
  return parts.map((part, index) => (
    <React.Fragment key={index}>
      {part}
      {index < parts.length - 1 && <br />}
    </React.Fragment>
  ));
};
